<template>
  <img
    class="tw-object-contain tw-h-[48px] xl:tw-h-[80px] tw-w-full tw-mb-4"
    alt="Uptogether"
    :src="logoUrl"
  />
</template>

<script>
export default {
  data() {
    return {
      logoUrl: '/logo.png',
    }
  },
}
</script>
